import styled from 'styled-components';
import { Form } from 'react-bootstrap';

export const FormWrapper = styled(Form)`
    margin-bottom: 20px;
    
    .panel > .panel-heading {
        background-image: none;
        background-color: whitesmoke;
        color: black;
    }

    & > .form-group {
        min-height: 30px;
    }

    & > .form-group:nth-child(odd) {
        background-color: #f9f9f9;
    }
`;
